import { render, staticRenderFns } from "./_two-column-layout.vue?vue&type=template&id=d0bcc616&scoped=true&"
import script from "./_two-column-layout.vue?vue&type=script&lang=js&"
export * from "./_two-column-layout.vue?vue&type=script&lang=js&"
import style0 from "./_two-column-layout.vue?vue&type=style&index=0&id=d0bcc616&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0bcc616",
  null
  
)

export default component.exports